import React from 'react';
import './OrderHistoryWidgetModal.css';
import SvgInkDrop from '../../../../components/SvgContainer/SvgInkDrop';
import SvgWarningCircle from '../../../../components/SvgContainer/SvgWarningCircle';
import { useTranslation } from 'react-i18next';
import { getInkTranslation } from '../../../../constants/AppMethod';

const OrderHistoryWidgetModal = ({orderHistoryList}) => {
    const { t } = useTranslation(["translation"]);
    const magentaInkDropsmall = <SvgInkDrop width={9} height={11} color='#F05FEF' ></SvgInkDrop>
    const yellowInkDropsmall = <SvgInkDrop width={9} height={11} color='#F5F44E' ></SvgInkDrop>
    const cyanInkDropsmall = <SvgInkDrop width={9} height={11} color='#A0F9FF' ></SvgInkDrop>
    const blackInkDropsmall = <SvgInkDrop width={9} height={11} color='black' ></SvgInkDrop>
    const warningBlueSmall = <SvgWarningCircle width={16} height={16}> </SvgWarningCircle>
    return(
        <>
        { orderHistoryList?.length && orderHistoryList?.map( orderData =>
            <div className="widgetModal">
                <div className='orderNameDiv'>
                    <span> {t("ORDERHISTORY.WIDGET.ORDER_NO")} : </span>
                    <span className="NameDiv">{orderData.orderId}</span>
                    <div className='orderDateDiv'>
                        <span>{orderData.displayDateFormat}</span>
                    </div>
                </div>
                <div className='inkColorContainer'>
                {orderData.supplyShippedProducts.map( shippedProduct => (
                    shippedProduct?.productColor && <div className='inkColorDiv'> {
                        shippedProduct?.productColor?.toLowerCase().trim() === 'magenta' ? magentaInkDropsmall 
                        : shippedProduct?.productColor?.toLowerCase().trim() === 'yellow' 
                        ? yellowInkDropsmall 
                        : shippedProduct?.productColor?.toLowerCase().trim() === 'cyan' 
                        ? cyanInkDropsmall 
                        : blackInkDropsmall
                        } { shippedProduct?.productColor && getInkTranslation(shippedProduct.productColor) } </div>
                )) }
                </div>
                <div className='shippedDiv'> {warningBlueSmall} {t("ORDERHISTORY.WIDGET.SHIPPED")} </div> 
            </div>
        )}
        </>
    )
}

export default OrderHistoryWidgetModal;